
export const GET_BLOG_HEADERS = 'GET_BLOG_HEADERS';
export const SET_BLOG_HEADERS = 'SET_BLOG_HEADERS';
export const ERROR_BLOG_HEADERS = 'ERROR_BLOG_HEADERS';